import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
export class TranslatedComponent extends Vue {
    get i18n() {
        return this.$store.getters.i18n;
    }
}
